import React from 'react';
import { motion } from 'framer-motion';
import faqBg from '../assets/faq.png'; 
import banner2 from '../assets/banner2.png';
import { ShieldCheck, BarChart3, Activity, Layers } from 'lucide-react';
import kidBg from "../assets/bgcloud.png";
import sp1 from "../assets/sp1.png";
import spReg from "../assets/sp-reg.png"
const SP = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* SECTION 1: WHAT IT IS (Image Left, Text Right) */}
           {/* SECTION 1: WHAT IT IS (Image Left, Text Right) */}
        <section
  className="relative py-16 md:py-24 text-center overflow-hidden"
  style={{
    backgroundImage: `url(${banner2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  

    <h3 className="relative z-10 font-syne text-[24px] md:text-[32px] text-slate-900 tracking-tight font-medium">
         Structured Products
        </h3>

  <div
    className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
    style={{
      background:
        "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
    }}
  />
</section>

 <section className="relative pt-20 pb-20 overflow-hidden bg-white">
        {/* Background Decor - Restored width for symmetry */}
        <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50 -z-10 hidden lg:block" />

        <div className="max-w-7xl mx-auto px-6 lg:px-24">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-15">
            
            {/* LEFT SIDE: CONTENT */}
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="w-full lg:w-3/5" // Takes up 60% of the space
            >
             
            
              <div className="space-y-6 max-w-xl"> {/* Prevents text from leaking into the center */}
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                Structured Products are customized investment solutions that combine traditional instruments like bonds with derivatives to offer unique risk–return outcomes.
                </p>
                
                <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
                 They are designed to provide capital protection, enhanced returns, or market-linked growth, depending on an investor’s goals and risk appetite.
                </p>

                <p className="text-slate-500 text-base md:text-lg font-medium border-l-4 border-red-600 pl-6 py-2 mt-8 italic">
                  Structured products are typically issued by banks or financial institutions and distributed to eligible investors through regulated intermediaries such as DreamLadder Capital.
                </p>
              </div>
            </motion.div>

            {/* RIGHT SIDE: IMAGE */}
            <motion.div 
              className="w-full lg:w-2/5 flex justify-end" // Takes up 40% and pins to the right margin
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="relative w-full max-w-[450px]"> 
                <div className="overflow-hidden rounded-sm"> {/* Clean edge like Our Story */}
                  <img 
                    src={sp1} 
                    alt="Mutual Funds Overview" 
                    className="w-full h-auto object-cover aspect-[4/3]"
                  />
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>


{/* SECTION: TYPES OF STRUCTURED PRODUCTS */}
{/* SECTION: TYPES OF STRUCTURED PRODUCTS */}
{/* SECTION: TYPES OF STRUCTURED PRODUCTS - STREAMLINED */}
<section 
  className="relative w-full pt-20 pb-28 overflow-hidden"
  style={{ 
    backgroundImage: `url(${kidBg})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center' 
  }}
>
  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">
    
    <div className="text-center mb-12">
      
      <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
        Types of Structured Products
      </h3>
      
      <p className="text-slate-600 text-lg md:text-xl leading-relaxed">
        Tailored investment solutions designed to provide optimized risk-reward profiles.
      </p>
    </div>

    {/* Reduced gap from 8 to 4 for compactness */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {[
        {
          title: "Capital-Protected Products",
          desc: "Offer downside protection while participating in market upside through index or equity-linked returns.",
          icon: <ShieldCheck size={20} className="text-red-600" strokeWidth={2} />
        },
        {
          title: "Non-Capital-Protected Products",
          desc: "Higher return potential with proportional exposure to market movements; suitable for informed, higher-risk investors.",
          icon: <BarChart3 size={20} className="text-red-600" strokeWidth={2} />
        },
        {
          title: "Fixed Income–Linked Notes",
          desc: "Combine bond returns with optional derivative exposure to enhance yield while maintaining a predictable payout.",
          icon: <Activity size={20} className="text-red-600" strokeWidth={2} />
        },
        {
          title: "Equity or Index-Linked Notes",
          desc: "Returns are tied to the performance of specific stocks, indices, or baskets of securities.",
          icon: <Layers size={20} className="text-red-600" strokeWidth={2} />
        }
      ].map((item, index) => (
        <motion.div 
          key={index}
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.05 }}
          
          className="p-6 rounded-xl bg-white/60 backdrop-blur-md border border-white/40 hover:bg-white/80 transition-all duration-300 shadow-sm"
        >
          <div className="flex items-center gap-3 mb-3">
            {/* Removed the background box from the icon to eliminate white space */}
            <div className="flex-shrink-0">
              {item.icon}
            </div>
            <h4 className="font-syne text-[18px] md:text-[20px] font-bold text-slate-900 tracking-tight leading-tight">
              {item.title}
            </h4>
          </div>

          {/* Reduced left padding as there is no icon box anymore */}
          <p className="text-slate-600 text-base md:text-lg font-medium pl-8">
            {item.desc} 
          </p>
        </motion.div>
      ))}
    </div>
  </div>
</section>


{/* SECTION: REGULATORY FRAMEWORK */}

<section 
  className="relative py-12 md:py-20 overflow-hidden bg-white"
  
>
  {/* TOP FADE: Blends section smoothly into the one above */}
  <div className="absolute top-0 left-0 w-full h-24 bg-gradient-to-b from-white via-white/40 to-transparent pointer-events-none z-0"></div>
  
  {/* BOTTOM FADE: Blends section smoothly into the one below */}
  <div className="absolute bottom-0 left-0 w-full h-20 bg-gradient-to-t from-white via-white/40 to-transparent pointer-events-none z-0"></div>

  <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-24">

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

      {/* LEFT: SECTION ANCHOR & IMAGE */}
      <div className="max-w-xl">
       
        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
        Regulatory Framework
      </h3>

        <div className="w-16 h-[3px] bg-red-600 mb-8"></div>

        <p className="text-slate-600 text-lg md:text-xl leading-relaxed font-medium mb-12">
          Structured Products in India operate within a tightly regulated
          framework to ensure transparency, investor protection, and
          suitability-based distribution.
        </p>

        {/* INTEGRATED IMAGE: sp-reg.png with soft shadow */}
        <div className="relative group">
          <img 
            src={spReg} 
            alt="Regulatory Compliance" 
            className="w-full h-auto drop-shadow-2xl rounded-2xl transform transition-transform duration-700 group-hover:scale-[1.02]"
          />
        </div>
      </div>

      {/* RIGHT: REGULATORY POINTS */}
      <div className="max-w-2xl">

        <div className="space-y-10">

          {[
            "Governed by SEBI (Issue and Listing of Structured Products) Regulations and applicable SEBI (ICDR) Guidelines.",
            "Products issued by banks and NBFCs are additionally subject to RBI regulations governing issuance, risk management, and balance sheet exposure.",
            "Distribution is restricted to eligible investors, typically High-Net-Worth Individuals (HNIs), based on suitability assessment and risk profiling.",
            "Issuers and distributors must ensure complete disclosure of payoff structures, underlying risks, costs, and scenario outcomes prior to investment."
          ].map((text, idx) => (
            <div key={idx} className="group flex gap-6">
              {/* FEEDBACK FIX: Number turns red on hover of the parent group */}
              <span className="text-slate-400 font-syne font-bold text-lg mt-[2px] transition-colors duration-300 group-hover:text-red-600">
                0{idx + 1}
              </span>
              <p className="text-slate-600 text-base md:text-lg font-medium transition-colors duration-300 group-hover:text-slate-900">
                {text}
              </p>
            </div>
          ))}

        </div>

        {/* Closing compliance note */}
        <div className="mt-16 border-l-4 border-red-600 pl-8 bg-slate-50/50 py-6 rounded-r-xl">
          <p className="text-slate-600 text-base md:text-lg leading-relaxed font-medium italic">
            This framework ensures structured products are offered only where
            they align with investor objectives, risk tolerance, and regulatory safeguards.
          </p>
        </div>

      </div>

    </div>
  </div>
</section>

<section
  className="py-10 md:py-14 text-center relative overflow-hidden "
  style={{
    backgroundImage: `url(${faqBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Shorter, more aggressive fade to keep the image original below the top edge */}
  <div className="absolute top-0 left-0 w-full h-20 bg-gradient-to-b from-white via-white/20 to-transparent pointer-events-none z-0"></div>

  <div className="relative z-10 px-6">
   
     <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter"> Why Structured Products?</h2>

    <p className="mt-4 text-base md:text-lg text-slate-600  font-medium max-w-2xl mx-auto">
      They enable investors to achieve customized portfolio outcomes—balancing capital preservation, yield enhancement, or equity participation—within a regulated and transparent framework.
  </p>
  </div>
</section>
    </div>
  );
};

export default SP;